/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Searchplaceholder1Inputs */

const id_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari game...`)
};

const ms_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari permainan...`)
};

const da_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter spil...`)
};

const de_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiele durchsuchen...`)
};

const en_us2_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search games...`)
};

const es_es2_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar juegos...`)
};

const es_mx2_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar juegos...`)
};

const fil_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga laro...`)
};

const fr_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des jeux…`)
};

const it_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca giochi...`)
};

const hu_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékok keresése...`)
};

const nl_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games zoeken...`)
};

const no_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter spill...`)
};

const pl_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj gier...`)
};

const pt_br2_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar jogos...`)
};

const pt_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar jogos...`)
};

const ro_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută jocuri...`)
};

const fi_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae pelejä...`)
};

const sv_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök spel...`)
};

const vi_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm game...`)
};

const tr_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun ara...`)
};

const cs_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat hry...`)
};

const bg_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на игри...`)
};

const ru_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск игр...`)
};

const uk_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук ігор...`)
};

const ar_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن ألعاب...`)
};

const hi_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम खोजें...`)
};

const th_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเกม...`)
};

const ja_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームを検索...`)
};

const zh_cn2_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索游戏...`)
};

const zh_hant1_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋遊戲...`)
};

const ko_common_searchplaceholder1 = /** @type {(inputs: Common_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 검색...`)
};

/**
* | output |
* | --- |
* | "Search games..." |
*
* @param {Common_Searchplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const common_searchplaceholder1 = /** @type {((inputs?: Common_Searchplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Searchplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_searchplaceholder1(inputs)
	if (locale === "ms") return ms_common_searchplaceholder1(inputs)
	if (locale === "da") return da_common_searchplaceholder1(inputs)
	if (locale === "de") return de_common_searchplaceholder1(inputs)
	if (locale === "en-US") return en_us2_common_searchplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_common_searchplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_common_searchplaceholder1(inputs)
	if (locale === "fil") return fil_common_searchplaceholder1(inputs)
	if (locale === "fr") return fr_common_searchplaceholder1(inputs)
	if (locale === "it") return it_common_searchplaceholder1(inputs)
	if (locale === "hu") return hu_common_searchplaceholder1(inputs)
	if (locale === "nl") return nl_common_searchplaceholder1(inputs)
	if (locale === "no") return no_common_searchplaceholder1(inputs)
	if (locale === "pl") return pl_common_searchplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_common_searchplaceholder1(inputs)
	if (locale === "pt") return pt_common_searchplaceholder1(inputs)
	if (locale === "ro") return ro_common_searchplaceholder1(inputs)
	if (locale === "fi") return fi_common_searchplaceholder1(inputs)
	if (locale === "sv") return sv_common_searchplaceholder1(inputs)
	if (locale === "vi") return vi_common_searchplaceholder1(inputs)
	if (locale === "tr") return tr_common_searchplaceholder1(inputs)
	if (locale === "cs") return cs_common_searchplaceholder1(inputs)
	if (locale === "bg") return bg_common_searchplaceholder1(inputs)
	if (locale === "ru") return ru_common_searchplaceholder1(inputs)
	if (locale === "uk") return uk_common_searchplaceholder1(inputs)
	if (locale === "ar") return ar_common_searchplaceholder1(inputs)
	if (locale === "hi") return hi_common_searchplaceholder1(inputs)
	if (locale === "th") return th_common_searchplaceholder1(inputs)
	if (locale === "ja") return ja_common_searchplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_common_searchplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_common_searchplaceholder1(inputs)
	return ko_common_searchplaceholder1(inputs)
});
export { common_searchplaceholder1 as "common.searchPlaceholder" }